import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  padding: ${({ theme }) =>
    `${theme.dimensions.spacing[4]} ${theme.dimensions.spacing[5]}`};
  border-bottom: 1px solid ${({ theme }) => theme.colors["grey-300"]};

  p {
    color: ${({ theme }) => theme.colors["grey-500"]};
    font-size: 14px;
    margin-bottom: 0px;
  }
`;

export const HeaderActionsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 4px;
  align-items: center;
`;
